import React from "react";
import { faGoogle } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { getGoogleAuthUrl } from "../../api/auth";
import Button from "./Button";

function GoogleAuthButton({ label }) {
  const handleGoogleAuth = () => {
    window.location.href = getGoogleAuthUrl();
  };

  return (
    <Button variant="google" onClick={handleGoogleAuth}>
      <span className="flex items-center justify-center gap-3">
        <FontAwesomeIcon icon={faGoogle} className="text-lg" />
        {label}
      </span>
    </Button>
  );
}

export default GoogleAuthButton;
